import React, { useEffect, useState } from 'react';
import { Button, Divider, Result, Row, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import Language from './tabs/Language';
import General from './tabs/General';

import { savePoiAction } from '../../../actions/AppCms/PoiActions';
import { history } from '../../../utils/history';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const { TabPane } = Tabs;

function callback(key) {

}

const AddPoi = ({ form }) => {
  const dispatch = useDispatch();

  const [finished, setFinished] = useState(false);

  const { cmsLanguageList } = useSelector(store => ({
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
  }, []);

  const handleGoReports = () => {
    history.push('/pois');
  };

  const handleGoAddNew = () => {
    window.location.reload();
  };

  const handleSubmit = e => {
    e.preventDefault();
    // const { form } = this.props;
    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const content = [];
        cmsLanguageList.map(item => {
          content.push({
            title: fieldsValue['title-' + item.isoLanguage.code],
            subtitle: fieldsValue['subtitle-' + item.isoLanguage.code],
            description: fieldsValue['description-' + item.isoLanguage.code],
            audioList: fieldsValue['audioList-' + item.isoLanguage.code],
            language: item.isoLanguage.code,
            state:
              fieldsValue['state-' + item.isoLanguage.code] ||
              (item.defaultInMobileApp &&
                fieldsValue['state-' + item.isoLanguage.code] === undefined)
                ? 'PUBLISHED'
                : 'INHERITED',
          });
          return null;
        });

        const values = {
          content,
          externalReference: fieldsValue.externalReference,
          imageList: fieldsValue.imageList,
          referenceImageList: fieldsValue.referenceImageList,
          featuredImage: fieldsValue.featuredImage
            ? fieldsValue.featuredImage[0]
            : null,
          group: {
            id: fieldsValue.group,
          },
          linkedItemIds: fieldsValue.linkedItemIds,
          beaconSensitivityRange: {
            min: fieldsValue.beaconSensitivityRange
              ? fieldsValue.beaconSensitivityRange[0]
              : -80,
            max: fieldsValue.beaconSensitivityRange
              ? fieldsValue.beaconSensitivityRange[1]
              : -20,
          },
          location: {
            location: fieldsValue.address,
            latitude: fieldsValue.latitude,
            longitude: fieldsValue.longitude,
          },
          youtubeLink: fieldsValue.youtubeLink,
        };

        dispatch(savePoiAction(values)).then(() => {
          setFinished(true);
        });
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 10 },
      xl: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 12 },
      xl: { span: 12 },
    },
  };

  //     const languageTabs=(
  //       cmsLanguageList.map((item)=>{

  // return ( <TabPane tab={item.isoLanguage.code} key={item.id}>

  // <Default form={form}  lang={item.isoLanguage.code}/>
  // </TabPane>)
  //       })
  //     );

  return (
    <CustomAddNewPageContent title="Add POI" subTitle="Point of Interest">
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Form {...formItemLayout} onSubmit={handleSubmit}>
          <Tabs onChange={callback}>
            <TabPane tab="GENERAL" key="1">
              <General form={form} submit={null} />
            </TabPane>
            {cmsLanguageList.map(item => (
              <TabPane
                tab={
                  item.isoLanguage.code +
                  (item.defaultInMobileApp ? ' (Default)' : '')
                }
                key={item.isoLanguage.id}
              >
                <Language
                  form={form}
                  langCode={item.isoLanguage.code}
                  language={item}
                  defaultLang={item.defaultInMobileApp}
                  submit={null}
                />
              </TabPane>
            ))}
          </Tabs>
          <Divider />
          <Row type="flex" justify="center">
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Row>
        </Form>
      )}
      {finished && (
        <Result
          status="success"
          title="Successfully saved poi!"
          extra={[
            <Button type="primary" key="console" onClick={handleGoReports}>
              Go to POIs
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              Add POI
            </Button>,
          ]}
        />
      )}
    </CustomAddNewPageContent>
  );
};

AddPoi.propTypes = {
  form: PropTypes.object,
  savePoiAction: PropTypes.func,
  match: PropTypes.object,
  cmsLanguageList: PropTypes.array,
  getCmsLanguagesAction: PropTypes.func,
};

const WrappedPoiForm = Form.create({
  name: 'WrappedPoi',
})(AddPoi);

function mapStateToProps({ cmsLanguageReducer }) {
  const { cmsLanguageList } = cmsLanguageReducer;
  return { cmsLanguageList };
}

const WrappedAddPoi = connect(mapStateToProps, {
  getCmsLanguagesAction,
  savePoiAction,
})(WrappedPoiForm);

export default WrappedAddPoi;
